module.exports = __webpack_public_path__ + "static/on_recrute-36904b6ac90b4d26b6ff7fbdad3cce5d.png";